import { gql } from '@apollo/client'

import { BRAND_CREATOR_FRAGMENT } from './fragments'

export const GET_BASIC_BRANDS_V2 = gql`
  query getBasicBrandsV2 {
    getWorkspace {
      id
      workspaceBrandV2 {
        id
        name
      }
      workspaceBrandCompetitorsPaginatedV2 {
        data {
          id
          name
        }
      }
    }
  }
`

export const GET_BRANDS_BY_INDUSTRY = gql`
  query getBrandsByIndustry($territoryId: ID!) {
    getTerritory(territoryId: $territoryId) {
      territoryId
      name
      ... on IndustryTopic {
        brands {
          id
          name
        }
      }
    }
  }
`

export const GET_LIST_BRAND_SOA_ON_CATEGORY_PAGINATED_QUERY = gql`
  query getListBrandSOAOnCategoryPaginated {
    listBrandSOAOnCategoryPaginated {
      data {
        id
        brand {
          id
          name
        }
        category {
          id
          name
        }
        language
      }
      totalCount
      cursor
    }
  }
`

export const GET_LIST_REASONING_ON_BRAND_CATEGORY_QUERY = gql`
  query getListReasoningOnBrandCategory($filterListReasoning: listReasoningInput!) {
    listReasoningOnBrandCategory(filters: $filterListReasoning) {
      brand {
        id
        name
      }
      title
      description
    }
  }
`

export const GET_DISTRIBUTION_METRICS = gql`
  query getBrandDistributionMetrics($timeRange: TimeRange, $providers: [Providers!], $publishedAt: RangeQuery) {
    getWorkspace {
      id
      workspaceBrand {
        id
        name
        workspaceBrandTerritories {
          earnedTerritory {
            name
            territoryId
            territoryPerformance {
              metrics(providers: $providers, publishedAt: $publishedAt, timeRange: $timeRange) {
                totalEngagement
                totalViews
              }
              totalPosts(timeRange: $timeRange, publishedAt: $publishedAt, providers: $providers)
            }
          }
          paidTerritory {
            name
            territoryId
            territoryPerformance {
              metrics(providers: $providers, publishedAt: $publishedAt, timeRange: $timeRange) {
                totalViews
                totalEngagement
              }
              totalPosts(providers: $providers, publishedAt: $publishedAt, timeRange: $timeRange)
            }
          }
          selfContentTerritory {
            name
            territoryId
            territoryPerformance {
              metrics(timeRange: $timeRange, providers: $providers, publishedAt: $publishedAt) {
                totalViews
                totalEngagement
              }
              totalPosts(timeRange: $timeRange, providers: $providers, publishedAt: $publishedAt)
            }
          }
        }
      }
    }
  }
`

export const GET_DISTRIBUTION_METRICS_V2 = gql`
  query getBrandDistributionMetricsV2($timeRange: TimeRange, $providers: [Providers!], $publishedAt: RangeQuery) {
    getWorkspace {
      id
      workspaceBrand: workspaceBrandV2 {
        id
        name
        workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
          earnedTerritory {
            name
            territoryId
            territoryPerformance {
              metrics(providers: $providers, publishedAt: $publishedAt, timeRange: $timeRange) {
                totalEngagement
                totalViews
              }
              totalPosts(timeRange: $timeRange, publishedAt: $publishedAt, providers: $providers)
            }
          }
          paidTerritory {
            name
            territoryId
            territoryPerformance {
              metrics(providers: $providers, publishedAt: $publishedAt, timeRange: $timeRange) {
                totalViews
                totalEngagement
              }
              totalPosts(providers: $providers, publishedAt: $publishedAt, timeRange: $timeRange)
            }
          }
          selfContentTerritory {
            name
            territoryId
            territoryPerformance {
              metrics(timeRange: $timeRange, providers: $providers, publishedAt: $publishedAt) {
                totalViews
                totalEngagement
              }
              totalPosts(timeRange: $timeRange, providers: $providers, publishedAt: $publishedAt)
            }
          }
        }
      }
    }
  }
`

export const GET_TOTAL_SHARE = gql`
  query getTotalShare(
    $timeRange: TimeRange
    $providers: [Providers!]
    $publishedAt: RangeQuery
    $interval: SparklineIntervalInput
  ) {
    getWorkspace {
      id
      workspaceBrandCompetitors {
        id
        name
        customSettings
        workspaceBrandTerritories {
          groupedTerritory {
            name
            territoryId
            territoryPerformance {
              metricsPerMonth(
                timeRange: $timeRange
                publishedAt: $publishedAt
                providers: $providers
                interval: $interval
              ) {
                totalEngagement
                totalViews
                date
              }
              metrics(timeRange: $timeRange, publishedAt: $publishedAt, providers: $providers) {
                totalEngagement
                totalViews
              }
              totalPosts(timeRange: $timeRange, providers: $providers, publishedAt: $publishedAt)

              videosPerMonth(
                providers: $providers
                timeRange: $timeRange
                interval: $interval
                publishedAt: $publishedAt
              ) {
                date
                videos
              }
            }
          }
        }
      }
      workspaceBrand {
        id
        name
        customSettings
        workspaceBrandTerritories {
          groupedTerritory {
            name
            territoryId
            territoryPerformance {
              metricsPerMonth(
                timeRange: $timeRange
                publishedAt: $publishedAt
                providers: $providers
                interval: $interval
              ) {
                totalEngagement
                totalViews
                date
              }
              metrics(timeRange: $timeRange, publishedAt: $publishedAt, providers: $providers) {
                totalEngagement
                totalViews
              }
              totalPosts(timeRange: $timeRange, providers: $providers, publishedAt: $publishedAt)
              videosPerMonth(
                providers: $providers
                timeRange: $timeRange
                interval: $interval
                publishedAt: $publishedAt
              ) {
                date
                videos
              }
            }
          }
        }
      }
    }
  }
`

export const GET_TOTAL_SHARE_V2 = gql`
  query getTotalShareV2(
    $timeRange: TimeRange
    $providers: [Providers!]
    $publishedAt: RangeQuery
    $interval: SparklineIntervalInput
  ) {
    getWorkspace {
      id
      workspaceBrand: workspaceBrandV2 {
        id
        name
        customSettings
        workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
          groupedTerritory {
            name
            territoryId
            territoryPerformance {
              metricsPerMonth(
                timeRange: $timeRange
                publishedAt: $publishedAt
                providers: $providers
                interval: $interval
              ) {
                totalEngagement
                totalViews
                date
              }
              metrics(timeRange: $timeRange, publishedAt: $publishedAt, providers: $providers) {
                totalEngagement
                totalViews
              }
              totalPosts(timeRange: $timeRange, providers: $providers, publishedAt: $publishedAt)
              videosPerMonth(
                providers: $providers
                timeRange: $timeRange
                interval: $interval
                publishedAt: $publishedAt
              ) {
                date
                videos
              }
            }
          }
        }
      }
      workspaceBrandCompetitorsPaginated: workspaceBrandCompetitorsPaginatedV2 {
        data {
          id
          name
          customSettings
          workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
            groupedTerritory {
              name
              territoryId
              territoryPerformance {
                metricsPerMonth(
                  timeRange: $timeRange
                  publishedAt: $publishedAt
                  providers: $providers
                  interval: $interval
                ) {
                  totalEngagement
                  totalViews
                  date
                }
                metrics(timeRange: $timeRange, publishedAt: $publishedAt, providers: $providers) {
                  totalEngagement
                  totalViews
                }
                totalPosts(timeRange: $timeRange, providers: $providers, publishedAt: $publishedAt)
                videosPerMonth(
                  providers: $providers
                  timeRange: $timeRange
                  interval: $interval
                  publishedAt: $publishedAt
                ) {
                  date
                  videos
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_BRAND_ID_LIST = gql`
  query getBrandIdList {
    getWorkspace {
      id
      workspaceBrand {
        id
        name
        workspaceBrandTerritories {
          earnedTerritory {
            name
            territoryId
          }
          groupedTerritory {
            name
            territoryId
          }
          paidTerritory {
            name
            territoryId
          }
          selfContentTerritory {
            name
            territoryId
          }
        }
      }
      workspaceBrandCompetitorsPaginated {
        data {
          id
          name
          workspaceBrandTerritories {
            earnedTerritory {
              name
              territoryId
            }
            groupedTerritory {
              name
              territoryId
            }
            paidTerritory {
              name
              territoryId
            }
            selfContentTerritory {
              name
              territoryId
            }
          }
        }
      }
    }
  }
`

export const GET_BRAND_ID_LIST_V2 = gql`
  query getBrandIdListV2 {
    getWorkspace {
      id
      workspaceBrand: workspaceBrandV2 {
        id
        name
        workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
          earnedTerritory {
            name
            territoryId
          }
          groupedTerritory {
            name
            territoryId
          }
          paidTerritory {
            name
            territoryId
          }
          selfContentTerritory {
            name
            territoryId
          }
        }
      }
      workspaceBrandCompetitorsPaginated: workspaceBrandCompetitorsPaginatedV2 {
        data {
          id
          name
          workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
            earnedTerritory {
              name
              territoryId
            }
            groupedTerritory {
              name
              territoryId
            }
            paidTerritory {
              name
              territoryId
            }
            selfContentTerritory {
              name
              territoryId
            }
          }
        }
      }
    }
  }
`

export const GET_BRAND_HASHTAGS = gql`
  query getBrandHashtags(
    $territoryId: ID!
    $hashtagsSize: Int! = 10
    $timeRange: TimeRange
    $providers: [Providers!]
    $publishedAt: RangeQuery
  ) {
    getTerritory(territoryId: $territoryId) {
      territoryId
      name
      territoryRelated {
        hashtags(
          size: $hashtagsSize
          filters: { providers: $providers, timeRange: $timeRange, publishedAt: $publishedAt }
        ) {
          data {
            name
            queryString
          }
        }
      }
    }
  }
`

const GROUPED_TERRITORY_FRAGMENT = gql`
  fragment BrandGroupedTerritoryFields on BrandTerritory {
    territoryId
    name
    brand {
      isVerified
      country
      thumbnailUrl
    }
    territoryPerformance {
      metrics {
        totalEngagement
        totalViews
      }
    }
  }
`

export const GET_BRANDS_FOR_DASHBOARD_TOOLBAR = gql`
  query getBrandsForDashboardToolbar {
    getWorkspace {
      id
      workspaceBrand: workspaceBrandV2 {
        id
        name
        thumbnail
        workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
          groupedTerritory {
            ...BrandGroupedTerritoryFields
          }
        }
      }
      workspaceBrandCompetitorsPaginated: workspaceBrandCompetitorsPaginatedV2 {
        data {
          id
          name
          thumbnail
          workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
            groupedTerritory {
              ...BrandGroupedTerritoryFields
            }
          }
        }
      }
    }
  }
  ${GROUPED_TERRITORY_FRAGMENT}
`

export const GET_BRAND_TERRITORY = gql`
  query getBrandTerritory($territoryId: ID!) {
    getTerritory(territoryId: $territoryId) {
      name
      territoryId

      ... on BrandTerritory {
        type
        territoryBrandColor
        brand {
          id
          name
          color
          thumbnailUrl
          isVerified
          country
        }
        territoryCreators {
          clusters {
            creators {
              topCreators {
                name
                creatorId
              }
            }
          }
        }
      }
    }

    getWorkspace {
      id
      myBrandSoA {
        category {
          country
        }
      }
      workspaceBrand: workspaceBrandV2 {
        id
        thumbnail
        customSettings
        workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
          groupedTerritory {
            territoryId
          }
          selfContentTerritory {
            territoryId
          }
          earnedTerritory {
            territoryId
          }
          paidTerritory {
            territoryId
          }
        }
      }
      workspaceBrandCompetitorsPaginated: workspaceBrandCompetitorsPaginatedV2 {
        data {
          id
          thumbnail
          customSettings
          workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
            groupedTerritory {
              territoryId
            }
            selfContentTerritory {
              territoryId
            }
            earnedTerritory {
              territoryId
            }
            paidTerritory {
              territoryId
            }
          }
        }
      }
    }
  }
`

// Total-creators counterpart of the creators tab query. `shouldReturnTotalCreators: true` collapses
// `clusters` to ONE CreatorClusterSubscriber holding the whole territory pool, so the aliases below
// carve that same pool: `mostEngaged` feeds the opening list (the partial CreatorClusterEngagement
// this mode doesn't return) and mega…nano feed the per-tier sections.
// `filters.audience` must stay out — the total path rejects it with 400.
export const GET_BRAND_CREATORS_TOTAL = gql`
  query getBrandCreatorsTotal(
    $territoryId: ID!
    $filters: TerritoryCreatorsTopCreatorsFilters
    $pool: SearchCreatorsInput
    $mostEngagedLimit: Int!
    $tierLimit: Int!
    $mega: SearchCreatorsInput
    $macro: SearchCreatorsInput
    $mid: SearchCreatorsInput
    $micro: SearchCreatorsInput
    $nano: SearchCreatorsInput
  ) {
    getTerritory(territoryId: $territoryId) {
      territoryId
      name
      territoryCreators {
        clusters(filters: $filters, shouldReturnTotalCreators: true) {
          id
          includedProviders
          mostEngaged: creators(query: $pool, limit: $mostEngagedLimit, sort: { field: "engagement", order: "desc" }) {
            rows
            entities {
              ... on Creator {
                ...BrandCreator
              }
            }
          }
          mega: creators(query: $mega, limit: $tierLimit) {
            rows
            entities {
              ... on Creator {
                ...BrandCreator
              }
            }
          }
          macro: creators(query: $macro, limit: $tierLimit) {
            rows
            entities {
              ... on Creator {
                ...BrandCreator
              }
            }
          }
          mid: creators(query: $mid, limit: $tierLimit) {
            rows
            entities {
              ... on Creator {
                ...BrandCreator
              }
            }
          }
          micro: creators(query: $micro, limit: $tierLimit) {
            rows
            entities {
              ... on Creator {
                ...BrandCreator
              }
            }
          }
          nano: creators(query: $nano, limit: $tierLimit) {
            rows
            entities {
              ... on Creator {
                ...BrandCreator
              }
            }
          }
        }
      }
    }
  }
  ${BRAND_CREATOR_FRAGMENT}
`
